/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_File_SearchInputs */

const es_tools_nexata_file_search = /** @type {(inputs: Tools_Nexata_File_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando archivos...`)
};

const en_tools_nexata_file_search = /** @type {(inputs: Tools_Nexata_File_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching files...`)
};

/**
* | output |
* | --- |
* | "Searching files..." |
*
* @param {Tools_Nexata_File_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_file_search = /** @type {((inputs?: Tools_Nexata_File_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_File_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_file_search(inputs)
	return en_tools_nexata_file_search(inputs)
});
export { tools_nexata_file_search as "tools.nexata.file_search" }